import './style.scss';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { Editor } from "react-draft-wysiwyg";
import { Box, Typography } from '@mui/material';
import { useLanguageContext } from '../../contexts/LanguageContext';
import { useEffect } from 'react';
import { ContentState, EditorState, convertFromHTML, convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import useState from '../../hooks/useState';


interface IRichTextEditorProps {
    label?: string;
    name: string;
    value: string;
    handleChange: (value: string) => void;
    required?: boolean;
    className?: string;
}

interface IStateValues {
    editorState: EditorState;
}


const RichTextEditor: React.FC<IRichTextEditorProps> = ({
    label = undefined,
    name,
    value,
    handleChange,
    required = false,
    className = '',
}) => {
    const { language } = useLanguageContext();

    const state = useState<IStateValues>({
        editorState: EditorState.createEmpty()
    });


    useEffect(() => {
        const html = convertFromHTML(value);
        const contentState = ContentState.createFromBlockArray(
            html.contentBlocks,
            html.entityMap,
        );

        state.update('editorState', EditorState.createWithContent(contentState));
        // eslint-disable-next-line
    }, []);


    useEffect(() => {
        const html = draftToHtml(convertToRaw(state.values.editorState.getCurrentContent()));
        handleChange(html);
        // eslint-disable-next-line
    }, [state.values.editorState]);

    return (
        <Box className={`richtexteditor-default ${className}`}>
            {
                label && <Typography className='richtexteditor-default-title'>
                    {label} {required ? '*' : ''}
                </Typography>
            }

            <Editor
                editorState={state.values.editorState}
                onEditorStateChange={e => state.update('editorState', e)}
                locale={language.initials.toLowerCase()}
                toolbar={{
                    options: [
                        'inline', 
                        'blockType',
                        'list', 
                        'textAlign', 
                        'emoji', 
                        'history'
                    ]
                }}
                toolbarClassName='richtexteditor-default-toolbar'
                wrapperClassName='richtexteditor-default-wrapper'
                editorClassName='richtexteditor-default-editor'
            />

            <input type='hidden' readOnly={true} name={name} required={required} value={value} />
        </Box>
    );
}


export default RichTextEditor;